import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadMaCpdDiplomasCreator,
  setMaCpdDiplomasPageCreator,
  setMaCpdDiplomasPerPageCreator,
  setMaCpdDiplomasSortCreator,
  setMaCpdDiplomasFiltersCreator,
} from '../../../../store/actionsCreators';
import CpdDiplomas from '../../../../shared/Cpd/Diplomas/CpdDiplomas';

const mapStateToProps = ({ loading, ma }) => ({
  loading: isLoading(loading, 'LOAD_MA_CPD_DIPLOMAS'),
  list: ma.diplomas,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadMaCpdDiplomasCreator()),
  setPage: (payload) => dispatch(setMaCpdDiplomasPageCreator(payload)),
  setPerPage: (payload) => dispatch(setMaCpdDiplomasPerPageCreator(payload)),
  setSort: (payload) => dispatch(setMaCpdDiplomasSortCreator(payload)),
  setFilters: (payload) => dispatch(setMaCpdDiplomasFiltersCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CpdDiplomas);
